import { useEffect } from "react";

import { signout } from "./NavBar/signout";

export default function SignoutPage() {
  useEffect(() => {
    signout();
  }, []);

  return null;
}
